export const FIELD_CANNOT_BE_EMPTY = 'Поле не может быть пустым'